export default "__VITE_ASSET__ae40123b__"